/**
 * Observability constants for the Tonnie Platform.
 */

/** HTTP header used to propagate trace IDs between client and API */
export const TRACE_ID_HEADER = 'x-trace-id';

/** Fallback header for backward compatibility with existing correlation IDs */
export const CORRELATION_ID_HEADER = 'x-correlation-id';

/** Prefix for generated trace IDs */
export const TRACE_ID_PREFIX = 'trace_';

/** Maximum string length for Sentry extra values */
export const SENTRY_EXTRA_MAX_LENGTH = 1000;

/** PostHog group type for tenant grouping */
export const POSTHOG_TENANT_GROUP = 'tenant';
